var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplefiligreeShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-192b591e-b11d-4395-b6ba-83bdb79339d6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.8 80.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.37,0l-2.21,1.98,26.2,23.53c-.17,0-.35,0-.52,0-28.31,0-49.12,6.87-61.9,20.44C-1.3,61.06,.02,79.14,.04,79.33l.08,.99,2.98-.24-.07-.99c-.01-.17-1.07-17.11,12.1-31.09,12.19-12.94,32.26-19.49,59.7-19.49,.2,0,.4,0,.6,0l-25.31,22.73-.95,.85,2.21,1.98,29.09-26.13,.34-.3v-1.21L51.37,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplefiligreeShare);
export default __webpack_public_path__ + "static/media/simple filigree - share.305176c19d598f1d6b4f1620473a77ef.svg";
export { ForwardRef as ReactComponent };